import React, { Component } from 'react'
import Helmet from 'react-helmet'

import Header from "../components/Nav.js";
// import Link from 'react-router-dom/Link';
// import axios from 'axios';
import autoBind from 'react-autobind'
// import { VideoCover } from 'react-video-cover'

// import Content from '../components/Content'
// import PageHeader from '../components/PageHeader'
import './Home.css'


export default class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      
    };
    autoBind(this);
  }

  play(){
    document.getElementById("renderVideo").innerHTML =  "<video controls autoPlay id='myVideo' ><source src='assets/TUSHEK_PROMO.mp4'  /></video>";
  }


  render() {
    const { title } = this.props.page
  return (
    <div>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      
      
    
        <Header />
        <div id="renderVideo" className="homeWrapper">

    {/*<img onClick={this.play} alt="" className="playB" src="/assets/icons/playB.png" />*/}
          <video autoPlay muted style={{display:"none"}} >
            <source src="/assets/TUSHEK_PROMO.mp4"  />
          </video>

          
        </div>
          
        
    </div>
  )
}}






// WEBPACK FOOTER //
// ./src/views/Home.js